// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/switch-to-standard-bank/switch-to-standard-bank.component.scss
// module id = 526
// module chunks = 0